<template>
  <ion-modal :is-open="isOpen" :backdrop-dismiss="false" class="card-modal">
    <ion-card>
      <ion-card-header>
        <ion-card-title>New Ability Unlocked!</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <div class="badge-container">
          <HexBadge v-if="rewardIcon" :icon="rewardIcon" :label="reward?.name ?? ''" />
        </div>
        <div class="ability-name">{{ reward?.name }}</div>
        <p class="description">{{ reward?.description }}</p>
        <p class="flavor-text">Earned by completing {{ campaignName }}</p>
        <ion-button @click="$emit('accept')" expand="block">Continue</ion-button>
      </ion-card-content>
    </ion-card>
  </ion-modal>
</template>

<script setup>
import { computed } from 'vue';
import { IonModal, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonButton } from '@ionic/vue';
import { componentRegistry } from '@/lib/ComponentRegistry';
import HexBadge from './components/HexBadge.vue';

const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
  },
  reward: {
    type: Object,
    required: true,
  },
  campaignName: {
    type: String,
    required: true,
  },
});

defineEmits(['accept']);

const rewardIcon = computed(() => {
  if (!props.reward?.component) return null;
  const ComponentClass = componentRegistry.get(props.reward.component);
  if (!ComponentClass) return null;
  const instance = new ComponentClass();
  if (typeof instance.getDisplayInfo !== 'function') return null;
  return instance.getDisplayInfo().icon;
});
</script>

<style scoped>
ion-card {
  --background: var(--hw-bg-surface);
  --color: var(--hw-text);
  text-align: center;
  padding: 20px;
}

ion-card-title {
  font-size: 2em;
  font-weight: bold;
  margin-bottom: 20px;
}

.badge-container {
  display: flex;
  justify-content: center;
  margin: 8px 0;
}

.ability-name {
  font-size: 1.8em;
  font-weight: bold;
  color: var(--hw-gold);
  margin: 16px 0;
}

.description {
  font-size: 1.1em;
  margin: 20px 0;
  line-height: 1.5;
}

.flavor-text {
  font-size: 0.9em;
  font-style: italic;
  color: var(--hw-text-muted);
  margin: 16px 0 24px 0;
}
</style>
